import React from "react";
import PropTypes from "prop-types";
import AccountName from "components/v3/subscription-details/account-name/AccountName";
import { FEEDBACK_URL } from "common/constants/Constants";
import styles from "../styles.module.scss";

const BusinessweekNotice = () => (
    <p>
        You are a current Bloomberg Businessweek subscriber.
        If you would like to subscribe for full website access,
        please <a href={ FEEDBACK_URL }>contact us</a> and we will be happy to assist you in changing your subscription.
    </p>
);

const AppleOrGoogleNotice = ({ provider }) => {
    const storeName = provider === "Apple"
        ? "App Store"
        : "Play Store";

    return (
        <p>
            You purchased your subscription to Bloomberg.com from the { provider } { storeName }.
            To change details or manage your subscription account, please visit the settings for your { provider } account.
        </p>
    );
};

AppleOrGoogleNotice.propTypes = {
    provider: PropTypes.string.isRequired
};

const CONTACT_MESSAGES = {
    cds: <BusinessweekNotice />,
    apple: <AppleOrGoogleNotice provider="Apple" />,
    google: <AppleOrGoogleNotice provider="Google" />
};

const GenericSubscriptionDetails = ({ productName, provider }) => {
    const noticeText = CONTACT_MESSAGES[provider.toLowerCase()] || null;

    return (
        <div className={ styles.details }>
            <AccountName productName={ productName } />
            <div className={ styles.notice }>
                { noticeText }
            </div>
        </div>
    );
};

GenericSubscriptionDetails.propTypes = {
    productName: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired
};

export default GenericSubscriptionDetails;
